import { useMutation, useQueryClient } from '@tanstack/react-query'
import * as aiSummariesApi from '@/api/aiSummaries'
import type { FeedbackRating } from '@/types'

function invalidateAiSummaries(qc: ReturnType<typeof useQueryClient>) {
  void qc.invalidateQueries({ queryKey: ['aiSummaries'] })
  void qc.invalidateQueries({ queryKey: ['coachingContext'] })
}

export function useSaveFeedback() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, rating, note }: { id: string; rating: FeedbackRating; note?: string }) =>
      aiSummariesApi.saveFeedback(id, rating, note),
    onSuccess: () => invalidateAiSummaries(qc),
  })
}

export function useDeleteSummary() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: aiSummariesApi.deleteSummary,
    onSuccess: () => invalidateAiSummaries(qc),
  })
}
